import React, { Suspense, useEffect } from 'react';
import Navigation from './navigation/Navigation';
import Loader from './components/Loader';
import setCssVariables from './utils/setColors';

const App = () => {
  useEffect(() => {
    setCssVariables();
  }, []);

  return (
    <Suspense fallback={<Loader />}>
      <Navigation />
    </Suspense>
  );
};

export default App;
